import {CSSObject} from "@emotion/react";

import avenirNextDemiEot from "stitch-design-system-content/src/assets/fonts/95da0114-2da9-4b03-9f4d-75864e43998e.eot";
import avenirNextDemiWoff2 from "stitch-design-system-content/src/assets/fonts/8c6d7851-9978-4520-8c8f-dc1b38b36eb6.woff2";
import avenirNextDemiWoff from "stitch-design-system-content/src/assets/fonts/73fd8503-a80c-4965-97ae-a1178b2caad0.woff";
import avenirNextDemiTtf from "stitch-design-system-content/src/assets/fonts/4dd3ecca-15ff-4b92-9355-6597b69e0522.ttf";

import avenirNextMediumEot from "stitch-design-system-content/src/assets/fonts/d44e7fd4-c56f-4173-a424-053487ceed84.eot";
import avenirNextMediumWoff2 from "stitch-design-system-content/src/assets/fonts/a1049d00-54ad-4589-95b8-d353f7ab52f0.woff2";
import avenirNextMediumWoff from "stitch-design-system-content/src/assets/fonts/13faf0ae-dcab-4d1c-9c08-f9ca339b6023.woff";
import avenirNextMediumTtf from "stitch-design-system-content/src/assets/fonts/297843ea-cf99-42a0-a97f-99f552bcc76b.ttf";

import avenirNextRegularEot from "stitch-design-system-content/src/assets/fonts/5d53f653-e4fa-44ce-9592-5d25067889ac.eot";
import avenirNextRegularWoff2 from "stitch-design-system-content/src/assets/fonts/f64c3634-1027-4aec-8bd4-d96f2444f559.woff2";
import avenirNextRegularWoff from "stitch-design-system-content/src/assets/fonts/91f23395-35b5-470e-9680-45d860e84f5b.woff";
import avenirNextRegularTtf from "stitch-design-system-content/src/assets/fonts/39581d84-4e26-4f6b-a1b3-de93f8d78fca.ttf";

import avenirNextLTProDemiEot from "stitch-design-system-content/src/assets/fonts/36B02F_0_0.eot";
import avenirNextLTProDemiWoff2 from "stitch-design-system-content/src/assets/fonts/36B02F_0_0.woff2";
import avenirNextLTProDemiWoff from "stitch-design-system-content/src/assets/fonts/36B02F_0_0.woff";
import avenirNextLTProDemiTtf from "stitch-design-system-content/src/assets/fonts/36B02F_0_0.ttf";

import LinotypeDidotWoff2 from "stitch-design-system-content/src/assets/fonts/Linotype-Didot.woff2";
import LinotypeDidotWoff from "stitch-design-system-content/src/assets/fonts/Linotype-Didot.woff";

import avenirNextLTProRegularEot from "stitch-design-system-content/src/assets/fonts/36B02F_1_0.eot";
import avenirNextLTProRegularWoff2 from "stitch-design-system-content/src/assets/fonts/36B02F_1_0.woff2";
import avenirNextLTProRegularWoff from "stitch-design-system-content/src/assets/fonts/36B02F_1_0.woff";
import avenirNextLTProRegularTtf from "stitch-design-system-content/src/assets/fonts/36B02F_1_0.ttf";

import euclidCircularBLightEot from "stitch-design-system-content/src/assets/fonts/EuclidCircularB-Light-WebS.eot";
import euclidCircularBLightWoff2 from "stitch-design-system-content/src/assets/fonts/EuclidCircularB-Light-WebS.woff2";
import euclidCircularBLightWoff from "stitch-design-system-content/src/assets/fonts/EuclidCircularB-Light-WebS.woff";
import euclidCircularBLightTtf from "stitch-design-system-content/src/assets/fonts/EuclidCircularB-Light-WebS.ttf";

import euclidCircularBBoldEot from "stitch-design-system-content/src/assets/fonts/EuclidCircularB-Bold-WebS.eot";
import euclidCircularBBoldWoff2 from "stitch-design-system-content/src/assets/fonts/EuclidCircularB-Bold-WebS.woff2";
import euclidCircularBBoldWoff from "stitch-design-system-content/src/assets/fonts/EuclidCircularB-Bold-WebS.woff";
import euclidCircularBBoldTtf from "stitch-design-system-content/src/assets/fonts/EuclidCircularB-Bold-WebS.ttf";

import franklinGothicHeavyEot from "stitch-design-system-content/src/assets/fonts/franklingothic-hvy-webfont.eot";
import franklinGothicHeavyWoff2 from "stitch-design-system-content/src/assets/fonts/franklingothic-hvy-webfont.woff2";
import franklinGothicHeavyWoff from "stitch-design-system-content/src/assets/fonts/franklingothic-hvy-webfont.woff";
import franklinGothicHeavyTtf from "stitch-design-system-content/src/assets/fonts/franklingothic-hvy-webfont.ttf";

import franklinGothicDemiEot from "stitch-design-system-content/src/assets/fonts/franklingothic-demi-webfont.eot";
import franklinGothicDemiWoff2 from "stitch-design-system-content/src/assets/fonts/franklingothic-demi-webfont.woff2";
import franklinGothicDemiWoff from "stitch-design-system-content/src/assets/fonts/franklingothic-demi-webfont.woff";
import franklinGothicDemiTtf from "stitch-design-system-content/src/assets/fonts/franklingothic-demi-webfont.ttf";

import franklinGothicBookEot from "stitch-design-system-content/src/assets/fonts/franklingothic-book-webfont.eot";
import franklinGothicBookWoff2 from "stitch-design-system-content/src/assets/fonts/franklingothic-book-webfont.woff2";
import franklinGothicBookWoff from "stitch-design-system-content/src/assets/fonts/franklingothic-book-webfont.woff";
import franklinGothicBookTtf from "stitch-design-system-content/src/assets/fonts/franklingothic-book-webfont.ttf";

import loraItalicEot from "stitch-design-system-content/src/assets/fonts/Lora-Italic.eot";
import loraItalicWoff2 from "stitch-design-system-content/src/assets/fonts/Lora-Italic.woff2";
import loraItalicWoff from "stitch-design-system-content/src/assets/fonts/Lora-Italic.woff";
import loraItalicTtf from "stitch-design-system-content/src/assets/fonts/Lora-Italic.ttf";

import monsterratRegularEot from "stitch-design-system-content/src/assets/fonts/Montserrat-Regular.eot";
import monsterratRegularWoff2 from "stitch-design-system-content/src/assets/fonts/Montserrat-Regular.woff2";
import monsterratRegularWoff from "stitch-design-system-content/src/assets/fonts/Montserrat-Regular.woff";
import monsterratRegularTtf from "stitch-design-system-content/src/assets/fonts/Montserrat-Regular.ttf";

import sourceSansProLightEot from "stitch-design-system-content/src/assets/fonts/SourceSansPro-Light.eot";
import sourceSansProLightWoff from "stitch-design-system-content/src/assets/fonts/SourceSansPro-Light.woff";
import sourceSansProLightTtf from "stitch-design-system-content/src/assets/fonts/SourceSansPro-Light.ttf";

import sourceSansProRegularEot from "stitch-design-system-content/src/assets/fonts/sourcesanspro-regular-webfont.eot";
import sourceSansProRegularWoff from "stitch-design-system-content/src/assets/fonts/sourcesanspro-regular-webfont.woff";
import sourceSansProRegularTtf from "stitch-design-system-content/src/assets/fonts/sourcesanspro-regular-webfont.ttf";

import sourceSansProBoldEot from "stitch-design-system-content/src/assets/fonts/sourcesanspro-bold-webfont.eot";
import sourceSansProBoldWoff from "stitch-design-system-content/src/assets/fonts/sourcesanspro-bold-webfont.woff";
import sourceSansProBoldTtf from "stitch-design-system-content/src/assets/fonts/sourcesanspro-bold-webfont.ttf";

import superiorTitleLightEot from "stitch-design-system-content/src/assets/fonts/SuperiorTitle-Light.eot";
import superiorTitleLightWoff2 from "stitch-design-system-content/src/assets/fonts/SuperiorTitle-Light.woff2";
import superiorTitleLightWoff from "stitch-design-system-content/src/assets/fonts/SuperiorTitle-Light.woff";
import superiorTitleLightTtf from "stitch-design-system-content/src/assets/fonts/SuperiorTitle-Light.ttf";

import arrowMediumRegularEot from "stitch-design-system-content/src/assets/fonts/tfarrowmedium-nor-webfont.eot";
import arrowMediumRegularWoff from "stitch-design-system-content/src/assets/fonts/tfarrowmedium-nor-webfont.woff";
import arrowMediumRegularTtf from "stitch-design-system-content/src/assets/fonts/tfarrowmedium-nor-webfont.ttf";
import {Brands} from "./theme";

type Src = {
  eot?: string;
  woff2?: string;
  woff?: string;
  ttf?: string;
};

type FontFamily = Required<
  Pick<CSSObject, "fontFamily" | "fontWeight" | "fontStyle">
> & {
  src: Src;
};

export const constructSrc = ({eot, woff2, woff, ttf}: Src): string => `
  url(${eot}),
  url(${eot}?#iefix) format("embedded-opentype"),
  ${woff2 ? `url(${woff2}) format("woff2"),` : ""}
  url(${woff}) format("woff"),
  url(${ttf}) format("truetype");
  `;

const brFontFamilies: FontFamily[] = [
  {
    fontFamily: "EuclidCircularB",
    fontStyle: "normal",
    fontWeight: 700,
    src: {
      eot: euclidCircularBBoldEot,
      woff2: euclidCircularBBoldWoff2,
      woff: euclidCircularBBoldWoff,
      ttf: euclidCircularBBoldTtf,
    },
  },
  {
    fontFamily: "EuclidCircularB",
    fontStyle: "normal",
    fontWeight: 300,
    src: {
      eot: euclidCircularBLightEot,
      woff2: euclidCircularBLightWoff2,
      woff: euclidCircularBLightWoff,
      ttf: euclidCircularBLightTtf,
    },
  },
  {
    fontFamily: "Linotype Didot",
    fontStyle: "normal",
    fontWeight: 400,
    src: {
      woff2: LinotypeDidotWoff2,
      woff: LinotypeDidotWoff,
    },
  },
];

const brfsFontFamilies: FontFamily[] = [
  ...brFontFamilies.slice(0, 2),
  {
    fontFamily: "TFArrowMedium-Regular",
    fontStyle: "normal",
    fontWeight: "normal",
    src: {
      eot: arrowMediumRegularEot,
      woff: arrowMediumRegularWoff,
      ttf: arrowMediumRegularTtf,
    },
  },
];

type FontTypes = Brands | "crossBrand" | "bright";

export const fontFamilies: Record<FontTypes, FontFamily[]> = {
  [Brands.Athleta]: [
    {
      fontFamily: "Avenir Next",
      fontStyle: "normal",
      fontWeight: 400,
      src: {
        eot: avenirNextRegularEot,
        woff2: avenirNextRegularWoff2,
        woff: avenirNextRegularWoff,
        ttf: avenirNextRegularTtf,
      },
    },
    {
      fontFamily: "Avenir Next",
      fontStyle: "normal",
      fontWeight: 500,
      src: {
        eot: avenirNextMediumEot,
        woff2: avenirNextMediumWoff2,
        woff: avenirNextMediumWoff,
        ttf: avenirNextMediumTtf,
      },
    },
    {
      fontFamily: "Avenir Next",
      fontStyle: "bold",
      fontWeight: 600,
      src: {
        eot: avenirNextDemiEot,
        woff2: avenirNextDemiWoff2,
        woff: avenirNextDemiWoff,
        ttf: avenirNextDemiTtf,
      },
    },
  ],
  [Brands.BananaRepublic]: brFontFamilies,
  [Brands.BananaRepublicFactoryStore]: brfsFontFamilies,
  [Brands.Gap]: [],
  [Brands.GapFactoryStore]: [],
  [Brands.HillCity]: [
    {
      fontFamily: "Avenir Next LT Pro",
      fontStyle: "normal",
      fontWeight: 600,
      src: {
        eot: avenirNextLTProDemiEot,
        woff2: avenirNextLTProDemiWoff2,
        woff: avenirNextLTProDemiWoff,
        ttf: avenirNextLTProDemiTtf,
      },
    },
    {
      fontFamily: "Avenir Next LT Pro",
      fontStyle: "normal",
      fontWeight: 400,
      src: {
        eot: avenirNextLTProRegularEot,
        woff2: avenirNextLTProRegularWoff2,
        woff: avenirNextLTProRegularWoff,
        ttf: avenirNextLTProRegularTtf,
      },
    },
    {
      fontFamily: "Superior Title Light",
      fontStyle: "normal",
      fontWeight: 300,
      src: {
        eot: superiorTitleLightEot,
        woff2: superiorTitleLightWoff2,
        woff: superiorTitleLightWoff,
        ttf: superiorTitleLightTtf,
      },
    },
  ],
  [Brands.OldNavy]: [
    {
      fontFamily: "FranklinGothic",
      fontStyle: "normal",
      fontWeight: 400,
      src: {
        eot: franklinGothicBookEot,
        woff2: franklinGothicBookWoff2,
        woff: franklinGothicBookWoff,
        ttf: franklinGothicBookTtf,
      },
    },
    {
      fontFamily: "FranklinGothic",
      fontStyle: "normal",
      fontWeight: 700,
      src: {
        eot: franklinGothicDemiEot,
        woff2: franklinGothicDemiWoff2,
        woff: franklinGothicDemiWoff,
        ttf: franklinGothicDemiTtf,
      },
    },
    {
      fontFamily: "FranklinGothic",
      fontStyle: "normal",
      fontWeight: 800,
      src: {
        eot: franklinGothicHeavyEot,
        woff2: franklinGothicHeavyWoff2,
        woff: franklinGothicHeavyWoff,
        ttf: franklinGothicHeavyTtf,
      },
    },
  ],
  crossBrand: [
    {
      fontFamily: "Source Sans Pro",
      fontStyle: "normal",
      fontWeight: 300,
      src: {
        eot: sourceSansProLightEot,
        woff: sourceSansProLightWoff,
        ttf: sourceSansProLightTtf,
      },
    },
    {
      fontFamily: "Source Sans Pro",
      fontStyle: "normal",
      fontWeight: 400,
      src: {
        eot: sourceSansProRegularEot,
        woff: sourceSansProRegularWoff,
        ttf: sourceSansProRegularTtf,
      },
    },

    {
      fontFamily: "Source Sans Pro",
      fontStyle: "normal",
      fontWeight: 600,
      src: {
        eot: sourceSansProBoldEot,
        woff: sourceSansProBoldWoff,
        ttf: sourceSansProBoldTtf,
      },
    },
  ],
  bright: [
    {
      fontFamily: "Monsterrat Regular",
      fontStyle: "normal",
      fontWeight: 400,
      src: {
        eot: monsterratRegularEot,
        woff2: monsterratRegularWoff2,
        woff: monsterratRegularWoff,
        ttf: monsterratRegularTtf,
      },
    },
    {
      fontFamily: "Lora Italic",
      fontStyle: "italic",
      fontWeight: 300,
      src: {
        eot: loraItalicEot,
        woff2: loraItalicWoff2,
        woff: loraItalicWoff,
        ttf: loraItalicTtf,
      },
    },
  ],
};

function flatMap<T, TRet>(coll: T[], fn: (el: T) => TRet[]): TRet[] {
  return coll.map(fn).reduce((acc, el) => acc.concat(el), []);
}

export function globalFonts(brand: Brands): CSSObject[] {
  const makeFontFamily = ({src, ...font}: FontFamily): CSSObject => ({
    "@font-face": {
      ...font,
      src: constructSrc(src),
    },
  });
  const fontTypes: FontTypes[] = [brand, "crossBrand", "bright"];
  return flatMap(fontTypes, (fontType) =>
    fontFamilies[fontType].map(makeFontFamily)
  );
}
